module.exports = __webpack_public_path__ + "media/src/img/payment/gp-ab07c30e3e547c0ef9dd6fa4a7292529.png";